import { Chakra } from "@airhelp/react-ui-components";
import PostListItem from "modules/common/components/PostListItem";
import type { RelatedArticlesProps } from "../RelatedArticles.d";

const { Box, Flex } = Chakra;

const PostListItemsMobile = ({ relatedArticles, fallbackFeaturedImage }: RelatedArticlesProps) =>
    <Box gridColumn="span 4" overflowX="scroll" overflowY="hidden" mx={-4}>
      <Flex px={4} py={1} display="inline-flex">
        {relatedArticles.map((story) => (
          <PostListItem
            key={story.id}
            story={story}
            fallbackFeaturedImage={fallbackFeaturedImage}
            width={72}
            mb={12}
            mr={6}
            _last={{ mr: 0 }}
          />
        ))}
      </Flex>
    </Box>

export default PostListItemsMobile;
